/* Optibio — shared shell behavior:
   - cart drawer
   - mobile nav drawer
   - announcement marquee duplication (seamless loop)
   - reveal-on-scroll
   - sticky add-to-cart proxy
   - tiny store (localStorage cart)
*/
(function () {
  // Mark JS-on so reveal animations can hide initially. CSS keeps content visible when JS is unavailable.
  document.documentElement.classList.add('js');

  const $$ = (s, r = document) => r.querySelectorAll(s);
  const $  = (s, r = document) => r.querySelector(s);

  // ----- Persistent cart -----
  const STORE_KEY = 'optibio.cart.v1';
  function readCart()   { try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; } catch { return []; } }
  function writeCart(c) { localStorage.setItem(STORE_KEY, JSON.stringify(c)); paintCart(); }
  function addToCart(item) {
    const cart = readCart();
    const existing = cart.find(x => x.sku === item.sku);
    if (existing) existing.qty += item.qty || 1;
    else cart.push({ ...item, qty: item.qty || 1 });
    writeCart(cart);
    openCart();
  }
  function removeLine(sku) { writeCart(readCart().filter(x => x.sku !== sku)); }
  function updateQty(sku, delta) {
    const cart = readCart();
    const it = cart.find(x => x.sku === sku);
    if (!it) return;
    it.qty = Math.max(1, it.qty + delta);
    writeCart(cart);
  }

  // Expose
  window.Optibio = { addToCart, openCart, closeCart, readCart };

  // ----- Cart drawer paint -----
  function paintCart() {
    const cart = readCart();
    const total = cart.reduce((s, l) => s + l.price * l.qty, 0);
    const count = cart.reduce((s, l) => s + l.qty, 0);

    $$('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count ? 'inline-flex' : 'none';
    });

    const body = $('.cart-drawer .body');
    if (body) {
      if (cart.length === 0) {
        body.innerHTML = `
          <div style="text-align:center; padding:48px 8px;">
            <p class="font-display" style="font-size:24px; font-weight:700; color:var(--navy-deep); margin:0 0 8px;">Your bag is empty.</p>
            <p style="color:var(--ink-mute); font-size:14px; margin:0 0 24px;">A 45-day supply is a good start.</p>
            <a href="product.html" class="btn btn-cta">Shop Optibio</a>
          </div>`;
      } else {
        body.innerHTML = cart.map(l => `
          <div class="cart-line" data-sku="${l.sku}">
            <div class="thumb"></div>
            <div>
              <div class="title">${l.title}</div>
              <div class="meta">${l.variant || ''}</div>
              <div class="qty">
                <button data-act="dec">−</button>
                <span>${l.qty}</span>
                <button data-act="inc">+</button>
                <button data-act="rm" style="margin-left:12px; text-decoration:underline; border:none; padding:0;">Remove</button>
              </div>
            </div>
            <div style="font-family:var(--display); font-weight:700; font-size:18px; color:var(--navy-deep);">$${(l.price * l.qty).toFixed(2)}</div>
          </div>
        `).join('');
        body.querySelectorAll('.cart-line').forEach(line => {
          const sku = line.dataset.sku;
          line.querySelector('[data-act="dec"]').addEventListener('click', () => updateQty(sku, -1));
          line.querySelector('[data-act="inc"]').addEventListener('click', () => updateQty(sku, +1));
          line.querySelector('[data-act="rm"]').addEventListener('click', () => removeLine(sku));
        });
      }
    }

    const foot = $('.cart-drawer .foot');
    if (foot) {
      foot.style.display = cart.length ? 'block' : 'none';
      const tEl = foot.querySelector('[data-cart-subtotal]');
      if (tEl) tEl.textContent = '$' + total.toFixed(2);
    }

    // Cart page
    const lines = $('#cart-page-lines');
    if (lines) {
      if (cart.length === 0) {
        lines.innerHTML = `<div style="padding:80px 0; text-align:center; border-top:1px solid var(--line);">
          <p class="font-display" style="font-size:36px; font-weight:700; color:var(--navy-deep); margin:0 0 8px;">Your cart is empty.</p>
          <p class="lede" style="margin:0 auto 32px;">A 45-day supply is one click away.</p>
          <a href="product.html" class="btn btn-cta btn-lg">Shop Optibio</a>
        </div>`;
      } else {
        lines.innerHTML = cart.map(l => `
          <div class="cart-page-line" data-sku="${l.sku}" style="display:grid; grid-template-columns:120px 1fr auto; gap:32px; align-items:center; padding:24px; border-radius:18px; background:rgba(255,255,255,0.6); border:1px solid rgba(255,255,255,0.8); margin-bottom:12px;">
            <div style="aspect-ratio:3/4; background:var(--mist-3); border-radius:10px;"></div>
            <div>
              <div class="font-display" style="font-weight:600; font-size:20px; line-height:1.2; color:var(--navy-deep); margin-bottom:6px;">${l.title}</div>
              <div style="color:var(--ink-mute); font-size:13px; margin-bottom:12px;">${l.variant || ''}</div>
              <div class="qty">
                <button data-act="dec">−</button>
                <span>${l.qty}</span>
                <button data-act="inc">+</button>
                <button data-act="rm" style="margin-left:16px; text-decoration:underline; border:none; padding:0;">Remove</button>
              </div>
            </div>
            <div style="font-family:var(--display); font-weight:700; font-size:24px; color:var(--navy-deep);">$${(l.price * l.qty).toFixed(2)}</div>
          </div>
        `).join('');
        lines.querySelectorAll('.cart-page-line').forEach(line => {
          const sku = line.dataset.sku;
          line.querySelector('[data-act="dec"]').addEventListener('click', () => updateQty(sku, -1));
          line.querySelector('[data-act="inc"]').addEventListener('click', () => updateQty(sku, +1));
          line.querySelector('[data-act="rm"]').addEventListener('click', () => removeLine(sku));
        });
      }
      const sub = $('#cart-page-subtotal');
      if (sub) sub.textContent = '$' + total.toFixed(2);
    }
  }

  function openCart()  { $('.cart-drawer')?.classList.add('open'); $('.cart-scrim')?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { $('.cart-drawer')?.classList.remove('open'); $('.cart-scrim')?.classList.remove('open'); document.body.style.overflow = ''; }
  function openMenu()  { $('.mobile-menu')?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { $('.mobile-menu')?.classList.remove('open'); document.body.style.overflow = ''; }

  // ----- Reveal on scroll -----
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  // ----- Wire up after DOM -----
  document.addEventListener('DOMContentLoaded', () => {
    paintCart();

    $$('.cart-toggle').forEach(b => b.addEventListener('click', openCart));
    $('.cart-scrim')?.addEventListener('click', closeCart);
    $$('.cart-close').forEach(b => b.addEventListener('click', closeCart));

    $$('.menu-open').forEach(b => b.addEventListener('click', openMenu));
    $$('.menu-close').forEach(b => b.addEventListener('click', closeMenu));

    // Reveal
    $$('.reveal').forEach(el => io.observe(el));

    // ----- Scroll progress bar (ethereal) -----
    if (!document.querySelector('.scroll-progress')) {
      const bar = document.createElement('div');
      bar.className = 'scroll-progress';
      document.body.appendChild(bar);
      const updateProgress = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const pct = max > 0 ? Math.max(0, Math.min(100, (window.scrollY / max) * 100)) : 0;
        bar.style.width = pct + '%';
      };
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
      updateProgress();
    }

    // Smooth scroll for in-page anchors (manual, no scrollIntoView)
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const t = document.getElementById(id);
      if (t) {
        e.preventDefault();
        const top = t.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });

    // ATC buttons with data attributes
    $$('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', () => {
        const sku = btn.dataset.sku;
        const title = btn.dataset.title;
        const variant = btn.dataset.variant;
        const price = parseFloat(btn.dataset.price);
        addToCart({ sku, title, variant, price, qty: 1 });
      });
    });
  });
})();


/* ===== Accessibility upgrades (WCAG 2.1 AA) — runs on every page ===== */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // 1) Skip link (2.4.1)
    if (!document.querySelector('.skip-link')) {
      var skip = document.createElement('a');
      skip.className = 'skip-link';
      skip.href = '#main-content';
      skip.textContent = 'Skip to content';
      document.body.insertBefore(skip, document.body.firstChild);
    }
    // 2) main landmark = first content <section> after the header (1.3.1 / 2.4.1)
    var main = null, header = document.querySelector('header');
    if (header) { var n = header.nextElementSibling; while (n && n.tagName !== 'SECTION') n = n.nextElementSibling; main = n; }
    if (!main) main = document.querySelector('body > section');
    if (main && !main.id) { main.id = 'main-content'; main.setAttribute('role', 'main'); main.setAttribute('tabindex', '-1'); }
    // 3) faux inputs get textbox semantics (4.1.2)
    document.querySelectorAll('.fauxinput').forEach(function (el) {
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') return;
      el.setAttribute('role', 'textbox');
      el.setAttribute('aria-readonly', 'true');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', (el.textContent || 'Input').trim());
    });
    // 4) every input/select/textarea gets an accessible name (3.3.2 / 4.1.2)
    document.querySelectorAll('input, textarea, select').forEach(function (inp) {
      if (inp.closest('label')) return; // a wrapping <label> already names it
      var named = inp.getAttribute('aria-label') || inp.getAttribute('aria-labelledby') ||
        (inp.id && document.querySelector('label[for="' + inp.id + '"]'));
      if (named) return;
      var ph = inp.getAttribute('placeholder');
      if (ph) inp.setAttribute('aria-label', ph); // only a real placeholder — never a type fallback
    });
    // 5) decorative inline SVG icons hidden from assistive tech (1.1.1)
    document.querySelectorAll('svg').forEach(function (svg) {
      if (svg.getAttribute('aria-label') || svg.getAttribute('role') === 'img') return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
    // 6) star ratings get a text alternative (1.1.1)
    document.querySelectorAll('.stars').forEach(function (s) {
      if (s.getAttribute('aria-label')) return;
      s.setAttribute('role', 'img');
      s.setAttribute('aria-label', '5 out of 5 stars');
    });
    // 7) icon-only links/buttons without a name get one from title/context (4.1.2)
    document.querySelectorAll('a, button').forEach(function (el) {
      var hasText = (el.textContent || '').trim().length > 0;
      var hasName = el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.getAttribute('title');
      if (!hasText && !hasName) {
        var t = el.getAttribute('href') === '#' ? 'Button' : 'Link';
        el.setAttribute('aria-label', t);
      }
    });
  });
})();
